import {
  Component,
  ContentChildren,
  HostListener,
  Input,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { EoSplitCol } from './eo-split-col.directive';
import { EoSplitColumn } from './eo-split-col.model';

@Component({
  selector: 'eo-split-layout',
  templateUrl: './eo-split-layout.component.html',
  styleUrl: './eo-split-layout.component.scss',
})
export class EoSplitLayoutComponent {
  mobile = false;

  @Input() style: any = { height: 'calc(100vh - 155px)' };
  styleProperties = {
    parentClass: 'flex flex-column gap-3 my-2 ml-1 p-0',
    childClass: 'flex justify-content-between align-items-end mb-2',
  };

  @ContentChildren(EoSplitCol)
  eoSplitColumns!: QueryList<EoSplitCol>;

  splitColumnTemplates: EoSplitColumn[] = [];

  ngOnInit() {
    this.mobile = window.screen.width <= 768;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.mobile = window.screen.width <= 768;
  }

  ngAfterContentInit() {
    this.splitColumnTemplates = this.eoSplitColumns.map((col) => ({
      template: col.templateRef,
      styleClass: col.styleClass,
      colSize: col.colSize,
      scrollHeight: col.scrollHeight,
    }));
  }
}
